import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import React, { Component } from 'react'
import { error, hide, info, removeAll, show, success, warning } from 'react-notification-system-redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Card, Header, Icon, Placeholder, Segment, Step } from 'semantic-ui-react'
import { SEARCH_ACTIONS } from '../actions/search'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import { Article } from '../components'
import { Articles } from '../containers'
import { createAlert } from '../lib/util'

class Duplicates extends Component {
    constructor(props) {
        super(props)
        this.state = {
            step: 0,
            article_one: {},
            article_two: {},
        }
    }

    componentDidMount() {
        let { sub, network } = this.props

        if (!sub) {
            this.props.toolbarResult([])
        }

        network.getStdArticleList()
        network.getVariantList()
    }

    prev() {
        let { step } = this.state

        this.clearSearch()
        this.setState({ step: Math.max(0, step - 1) })
    }

    next() {
        let { step } = this.state

        this.clearSearch()
        this.setState({ step: Math.min(2, step + 1) })
    }

    clearSearch() {
        this.props.searchResult('')
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { success, error } = this.props

        if (this.props.assigningDuplicates !== prevProps.assigningDuplicates) {
            if (!this.props.assigningDuplicates) {
                if (this.props.assignStatus.success) {
                    // Navigate back, success!
                    success(createAlert('Operazione completata.', 'Operazione avvenuta con successo!'))
                    this.setState({
                        status: 'success',
                        step: 0,
                        article_one: {},
                        article_two: {},
                    })
                } else {
                    error(createAlert('Errore del server', 'Riprova piú tardi'))
                }
            }
        }
    }

    doAssign() {
        let { article_one, article_two } = this.state
        let { network } = this.props

        console.log('Assigning article', article_one, 'to article_two', article_two)
        network.doAssignDuplicates(article_one, article_two)
    }

    render() {
        let { step, article_one, article_two } = this.state
        let { fetchingArticles } = this.props
        let content = <div />

        let variantCount = article_two.length

        let placeholders = []
        for (let i = 0; i < 3; i++) {
            placeholders.push(
                <Card key={i} style={{ width: '100%', margin: 8 }}>
                    <Card.Content>
                        <Placeholder>
                            <Placeholder.Header image>
                                <Placeholder.Line />
                                <Placeholder.Line />
                            </Placeholder.Header>
                            <Placeholder.Paragraph>
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                            </Placeholder.Paragraph>
                        </Placeholder>
                    </Card.Content>
                </Card>
            )
        }

        content = [
            <Step.Group key="stepgroup">
                <Step active={step === 0} completed={step > 0}>
                    <Icon name="image" />
                    <Step.Content>
                        <Step.Title>Articolo uno</Step.Title>
                        <Step.Description>{article_one.article_oneId ? article_one.article_oneName : 'Quale articolo?'}</Step.Description>
                    </Step.Content>
                </Step>

                <Step active={step === 1} completed={step > 1} disabled={step < 1}>
                    <Icon name="images" />
                    <Step.Content>
                        <Step.Title>Articolo due</Step.Title>
                        <Step.Description>
                            {variantCount > 0 ? `Selezionate ${variantCount} varianti` : 'Duplicato di quale articolo?'}
                        </Step.Description>
                    </Step.Content>
                </Step>

                <Step active={step === 2} completed={step > 2} disabled={step < 2}>
                    <Icon name="gem" />
                    <Step.Content>
                        <Step.Title>Conferma</Step.Title>
                        <Step.Description>Conferma assegnazione</Step.Description>
                    </Step.Content>
                </Step>
            </Step.Group>,
            <View column fullw fullh style={{ overflow: 'hidden', marginTop: 0 }} key="stepcontent">
                {
                    {
                        0: (
                            <View column fullw fullh style={{ height: '95%' }}>
                                <Articles
                                    noActions
                                    sub
                                    searchable
                                    selectable
                                    noPagination
                                    selected={article_one}
                                    style={{ height: '100%', overflowY: 'scroll' }}
                                    onChange={(article_one) => {
                                        console.log('Steps chose article_one', article_one)
                                        this.next()
                                        this.setState({ article_one })
                                    }}
                                />
                            </View>
                        ),
                        1: (
                            <View column fullw fullh style={{ height: '95%' }}>
                                <Articles
                                    noActions
                                    sub
                                    searchable
                                    selectable
                                    noPagination
                                    selected={article_two}
                                    style={{ height: '100%', overflowY: 'scroll' }}
                                    onChange={(article_two) => {
                                        console.log('Steps chose article_two', article_two)
                                        this.next()
                                        this.setState({ article_two })
                                    }}
                                />
                            </View>
                        ),
                        2: (
                            <View column fullw fullh style={{ overflowY: 'scroll' }}>
                                <Segment.Group>
                                    <Segment>
                                        <Header>Impostando</Header>
                                        <Article type="full" noActions article={article_one} />
                                    </Segment>
                                    <Segment>
                                        <Header>Come duplicato di</Header>
                                        <Article type="full" noActions article={article_two} />
                                    </Segment>
                                </Segment.Group>
                            </View>
                        ),
                    }[step]
                }
                <View fullw style={{ position: 'absolute', bottom: 16, right: 16, zIndex: 10, justifyContent: 'flex-end' }}>
                    <Button onClick={() => this.prev()}>Indietro</Button>
                    {step < 2 && (
                        <Button
                            color="black"
                            onClick={() => this.next()}
                            disabled={(step === 0 && !article_one.article_oneId) || (step === 0 && variantCount === 0)}
                        >
                            Avanti
                        </Button>
                    )}
                    {step === 2 && (
                        <Button color="green" onClick={() => this.doAssign()}>
                            Conferma
                        </Button>
                    )}
                </View>
            </View>,
        ]


        console.log('Duplicates render', fetchingArticles)

        return (
            <View fullw fullh column style={{ padding: 16 }}>
                {content}
            </View>
            // <View fullw fullh column style={{ padding: 16, ...(!fetchingArticles ? hiddenStyle : {}) }}>
            //     {placeholderContent}
            // </View>
        )
    }

    handleInput(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        this.setState({
            [name]: value,
        })
    }
}

const mapStateToProps = (state) => {
    let { doAssignDuplicates, getStdArticleList, search, organization } = state

    return {
        assigningDuplicates: doAssignDuplicates.fetching,
        assignStatus: doAssignDuplicates.status,
        fetchingArticles: getStdArticleList.fetching,
        search,
        organization,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),

        searchRequest: (result) => SEARCH_ACTIONS.request(result, dispatch),
        searchResult: (result) => SEARCH_ACTIONS.result(result, dispatch),
        searchError: (result) => SEARCH_ACTIONS.error(result, dispatch),

        show: (notif) => dispatch(show(notif)),
        success: (notif) => dispatch(success(notif)),
        error: (notif) => dispatch(error(notif)),
        warning: (notif) => dispatch(warning(notif)),
        info: (notif) => dispatch(info(notif)),
        hide: (notif) => dispatch(hide(notif)),
        removeAll: (notif) => dispatch(removeAll(notif)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(Duplicates)))
